<template>
  <div class="row">
    <div class="col-4">
      <div class="left-banner">
        <img src="@/assets/images/logo_white.png"
             alt="">
      </div>

    </div>

    <div class="col-8">

      <div class="right-form">

        <p class="text-center lead mb-5">
          ลงชื่อเข้าใช้งานระบบร้านค้ารับพัสดุของคุณ
        </p>

        <Card>
          <div slot="body">
            <ValidationObserver v-slot="{ invalid }">
              <form @submit.prevent="handleRegister"
                    class="p-2">
                <TextBox type="text"
                         id="username-textbox"
                         label="ผู้ใช้งาน"
                         placeholder="ผู้ใช้งาน"
                         rules="required"
                         v-model="registerForm.username" />

                <TextBox type="email"
                         id="email-textbox"
                         :label="$t('general.email')"
                         :placeholder="$t('general.email')"
                         rules="required"
                         v-model="registerForm.email" />
                <TextBox type="password"
                         id="password-textbox"
                         :label="$t('general.password')"
                         :placeholder="$t('general.password')"
                         rules="required"
                         v-model="registerForm.password" />

                <TextBox type="password"
                         id="password-confirm-textbox"
                         label="ยืนยันรหัสผ่าน "
                         placeholder="ยืนยันรหัสผ่าน "
                         rules="required"
                         v-model="registerForm.passwordConfirmation" />

                <div class="auth-box__cta-wrapper d-flex justify-content-between">
                  <Button id="submit-register-form-button"
                          :disabled="invalid"
                          class="btn-block"
                          variant="danger"
                          size="md"
                          :loading="registerLoading">สมัคร</Button>
                </div>
              </form>
            </ValidationObserver>
            <p class="mt-4 text-center">
              <router-link :to="{ name: 'Login' }"> เข้าระบบ </router-link>
            </p>
          </div>
        </Card>
      </div>
    </div>
  </div>
</template>

<script>
import Button from "@/components/core/Button";
import TextBox from "@/components/core/TextBox";
import { mapGetters } from "vuex";
import Card from "@/components/core/Card";
import { Toast, ToastFix } from '../helpers/toastr';

export default {
  name: "Register",
  components: {
    TextBox,
    Button,
    Card
  },

  data() {
    return {
      registerLoading: false,
      registerForm: {
        email: null,
        password: null,
      },
    };
  },

  methods: {
    handleRegister() {

      if (this.registerForm.password !== this.registerForm.passwordConfirmation) {
        Toast("Passwords do not match", "warning")
        return;
      }

      this.registerLoading = true;
      this.$store.dispatch("user/register", {
        data: this.registerForm,
        callback: (status, data) => {
          if (status) {
            this.$router.push({ name: "Seller-Settings-Account" });
          }
          this.registerLoading = false;
        },
      });
    },
  },

  computed: {
    ...mapGetters("onboard", ["firstVisit"]),
  },
};
</script>


<style lang="scss"
       scoped>

      .left-banner {
        background-color: red;
        height: 100vh;
        position: relative;

        img {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 80%;
        }
      }

      .right-form {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    </style>